import { render, staticRenderFns } from "./StreamTailorPayments.vue?vue&type=template&id=8abe7a06&"
import script from "./StreamTailorPayments.vue?vue&type=script&lang=ts&"
export * from "./StreamTailorPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports